import React from 'react';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './PageBackLayout.css';
import Icon, { IconSizes } from '../foundations/Icon';

const PageBackLayout = ({
    children,
    title,
    goBackTitle = 'STATIC.BUTTONS.GO_BACK',
    onBackClick,
    containerPopup,
    translateData,
}) => {
    return (
        <div className={classNames(css.containerPopup, containerPopup)}>
            <div className={css.header}>
                <div className={css.goBackContainer} onClick={onBackClick}>
                    <Icon size={IconSizes.SMALL} name="chevron-left" />
                    <div className={css.goBackText}>
                        <Translate id={goBackTitle} />
                    </div>
                </div>
                <div className={css.title}>
                    <Translate id={title} data={translateData} />
                </div>
            </div>
            {children || null}
        </div>
    );
};

PageBackLayout.propTypes = {
    children: PropTypes.array,
    goBackTitle: PropTypes.string,
    onBackClick: PropTypes.func,
    containerPopup: PropTypes.object,
    translateData: PropTypes.object,
    title: PropTypes.string,
};

export default PageBackLayout;
